import { render, staticRenderFns } from "./VxCellDraggable.vue?vue&type=template&id=071d7b36&"
import script from "./VxCellDraggable.vue?vue&type=script&lang=js&"
export * from "./VxCellDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports